import { render, staticRenderFns } from "./CreateMomentIcon.vue?vue&type=template&id=20a3aef4&scoped=true&"
import script from "./CreateMomentIcon.vue?vue&type=script&lang=js&"
export * from "./CreateMomentIcon.vue?vue&type=script&lang=js&"
import style0 from "./CreateMomentIcon.vue?vue&type=style&index=0&id=20a3aef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3aef4",
  null
  
)

export default component.exports